<template>
  <button
    class="tw:flex tw:flex-nowrap tw:rounded tw:border-0 tw:bg-transparent tw:p-0 tw:text-left tw:text-inherit tw:focus-visible:outline tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-denim-9"
    :class="{
      'tw:cursor-pointer': !readOnly && !disabled,
      'tw:cursor-default': readOnly || disabled,
      'tw:min-h-16.5 tw:w-full tw:focus-visible:outline-none': stacked,
    }"
    :disabled="disabled"
    type="button"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
interface MetricWidgetButtonProps {
  disabled?: boolean;
  readOnly?: boolean;
  stacked?: boolean;
}

const { disabled, readOnly, stacked } = defineProps<MetricWidgetButtonProps>();
</script>
